module.exports = __webpack_public_path__ + "static/media/become-panda-area-bg.68d8c539.png";